module.exports = __webpack_public_path__ + "bc6f50f05b028046985d09f7b47a274b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/RW.svg
// module id = J+jE
// module chunks = 0